import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paises-categoria',
  templateUrl: './paises-categoria.component.html',
  styleUrls: ['./paises-categoria.component.css']
})
export class PaisesCategoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
